import { format } from 'date-fns'
import { configApi } from '../http-client.js'
import { DATE_FORMAT, DATE_FORMAT_WEEK, DATE_FORMAT_DAY, DATE_FORMAT_MONTH_YEAR_SHORT } from '../date-formatting.js'
import { chartColors } from '../chart-colors.js'
/// interval = 0 (day), 1 (week), 2 (month)

export const HEALTH_CHART_TYPE = 9

export const getDashboardData = ({
	interval,
	startDate,
	endDate,
	formId,
	brandId,
	dashboardId,
	domain,
	fragments = null
}) =>
	configApi
		.post('api/Dashboard/GetDashboardInfo', {
			startDate,
			endDate,
			widgetId: parseInt(formId, 10),
			interval: parseInt(interval, 10),
			brandId: parseInt(brandId, 10),
			dashboardId: parseInt(dashboardId, 10),
			domain,
			fragments
		})
		.then(response => response.data)

const ChartTypes = {
	1: 'AreaChart',
	2: 'BarChart',
	3: 'BubbleChart',
	4: 'PieChart',
	5: 'LineChart',
	6: 'PolarChart',
	7: 'RadarChart',
	8: 'ScatterChart',
	9: 'HealthChart',
	10: 'DoughnutChart'
}
const INTERVALS = {
	DAY: 0,
	WEEK: 1,
	MONTH: 2
}

export const getDashboardChartsData = ({
	interval,
	startDate,
	endDate,
	formId,
	brandId,
	dashboardId,
	fragments = null
}) =>
	configApi
		.post('api/Dashboard/GetDashboardCharts', {
			startDate,
			endDate,
			widgetId: parseInt(formId, 10),
			interval: parseInt(interval, 10),
			brandId: parseInt(brandId, 10),
			dashboardId: parseInt(dashboardId, 10),
			fragments
		})
		.then(response => {
			return response.data.charts.map(chart => ({
				...chart,
				chartOptions: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						yPrimary: {
							min: chart.min,
							max: chart.max
						}
					}
				},
				chartData: {
					datasets: chart.chartData.datasets
						? chart.chartData.datasets.map((dataset, index) => ({
							data: dataset.data,
							label: dataset.label,
							backgroundColor: chartColors[index % chartColors.length]
						}))
						: [],
					labels: chart.chartData.labels.map(label => {
						switch (interval) {
							case INTERVALS.DAY:
								return format(new Date(label), DATE_FORMAT_DAY)
							case INTERVALS.WEEK:
								return `WC ${format(new Date(label), DATE_FORMAT_WEEK)}`
							case INTERVALS.MONTH:
								return format(new Date(label), DATE_FORMAT_MONTH_YEAR_SHORT)
							default:
								return format(new Date(label), DATE_FORMAT)
						}
					})
				},
				chartType: ChartTypes[chart.chartTypeId]
			}))
		})

export const getDomains = () => {
	return configApi.get(`api/Dashboard/GetDomains`).then(res => res.data)
}

export const getCookieWidgets = () => {
	return configApi.get(`api/Dashboard/GetCookieWidgets`).then(res => res.data)
}
